import React from 'react';

export const ChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 15.9677C11.185 15.9677 11.3551 15.9312 11.5103 15.8582C11.6654 15.7852 11.8146 15.6757 11.9579 15.5298L18.6986 8.51428C18.9254 8.27709 19.0388 7.98819 19.0388 7.64761C19.0388 7.42866 18.985 7.22491 18.8776 7.03637C18.7702 6.84783 18.624 6.69578 18.439 6.58023C18.2599 6.47075 18.06 6.41602 17.8392 6.41602C17.505 6.41602 17.2126 6.54374 16.9619 6.79918L11 13.0484L5.03811 6.79918C4.78149 6.54374 4.48906 6.41601 4.16083 6.41601C3.93405 6.41601 3.73114 6.47075 3.5521 6.58023C3.37307 6.69578 3.22984 6.84783 3.12242 7.03637C3.01499 7.22491 2.96128 7.42866 2.96128 7.64761C2.96128 7.98819 3.07467 8.27708 3.30145 8.51428L10.0422 15.5298C10.1854 15.6818 10.3346 15.7913 10.4898 15.8582C10.6509 15.9312 10.821 15.9677 11 15.9677Z"
      fill="currentColor"
    />
  </svg>
);
